import { render, staticRenderFns } from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=template&id=3a04d5ca&scoped=true"
import script from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=style&index=0&id=3a04d5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04d5ca",
  null
  
)

export default component.exports